import defaultTheme from './defaultTheme';
import rusticCottageTheme from './rusticCottageTheme';
import darkTheme from './darkTheme';
import adventurePassionTheme from './adventurePassionTheme';

export type ThemeName = 'default' | 'rusticCottage' | 'dark' | 'adventurePassion';

export const themes = {
  default: defaultTheme,
  rusticCottage: rusticCottageTheme,
  dark: darkTheme,
  adventurePassion: adventurePassionTheme,
};

export const getTheme = (themeName: ThemeName) => {
  return themes[themeName] || themes.default;
};

export const getAvailableThemes = (): ThemeName[] => {
  return Object.keys(themes) as ThemeName[];
};

// Helper function to map theme names from API to local theme names
export const mapThemeName = (apiThemeName: string): ThemeName => {
  const lowerName = apiThemeName.toLowerCase();
  if (lowerName.includes('cottage') || lowerName.includes('rustic')) return 'rusticCottage';
  if (lowerName.includes('dark')) return 'dark';
  if (lowerName.includes('adventure') || lowerName.includes('passion')) return 'adventurePassion';
  return 'default';
};

export {
  defaultTheme,
  rusticCottageTheme,
  darkTheme,
  adventurePassionTheme,
};

export default themes; 